__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "sopplus-template";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", function() { return __webpack_require__.e(58).then(function() { return function() { return __webpack_require__(57058); }; }); });
			register("@emotion/styled", "11.14.1", function() { return Promise.all([__webpack_require__.e(127), __webpack_require__.e(903)]).then(function() { return function() { return __webpack_require__(45903); }; }); });
			register("@mui/styles", "5.18.0", function() { return Promise.all([__webpack_require__.e(728), __webpack_require__.e(967)]).then(function() { return function() { return __webpack_require__(11728); }; }); });
			register("@mui/system", "5.18.0", function() { return Promise.all([__webpack_require__.e(728), __webpack_require__.e(127), __webpack_require__.e(539), __webpack_require__.e(675)]).then(function() { return function() { return __webpack_require__(72927); }; }); });
			register("@sui/provider", "3.0.14", function() { return __webpack_require__.e(348).then(function() { return function() { return __webpack_require__(47967); }; }); });
			register("antd", "5.28.1", function() { return Promise.all([__webpack_require__.e(215), __webpack_require__.e(874), __webpack_require__.e(293), __webpack_require__.e(498), __webpack_require__.e(517), __webpack_require__.e(911), __webpack_require__.e(879), __webpack_require__.e(721), __webpack_require__.e(621), __webpack_require__.e(83)]).then(function() { return function() { return __webpack_require__(29291); }; }); });
			register("react-dom", "17.0.2", function() { return function() { return __webpack_require__(97950); }; }, 1);
			register("react-router-dom", "6.3.0", function() { return function() { return __webpack_require__(51318); }; }, 1);
			register("react-router", "6.3.0", function() { return function() { return __webpack_require__(86971); }; }, 1);
			register("react", "17.0.2", function() { return function() { return __webpack_require__(65043); }; }, 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};